import React from 'react';

import { getImgixSrc } from '@utils/images';

import MobileStepWithMedia from '../MobileStepWithMedia';

interface TitvProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const TITV_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/titv.png',
  isEnvDependent: false,
});

const Titv = ({ handleClose, handleNext, isProSubscriber, step, totalSteps = 5 }: TitvProps) => (
  <MobileStepWithMedia
    description="First in tech news and analysis from the people who break and shape the story. Watch every weekday at 10 am PT/1 pm ET."
    handleClose={handleClose}
    handleNext={handleNext}
    isProSubscriber={isProSubscriber}
    media={
      <img
        src={TITV_IMAGE_SRC}
        alt="The Information’s TITV"
        className="h-full w-full object-cover object-top"
      />
    }
    showCloseButton={true}
    step={step}
    title="The Information’s TITV"
    totalSteps={totalSteps}
  />
);

export default Titv;
